module.exports = __webpack_public_path__ + "img/cl.88c8b5b1.png";